"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typography = {
    fonts: {
        rubik: `Rubik, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    },
    fontSizes: {
        'font-10': '10px',
        'font-12': '12px',
        'font-15': '15px',
        'font-8': '8px',
    },
    fontWeights: {
        'weight-400': 400,
        'weight-500': 500,
    },
    lineHeights: {
        'lh-10': '10px',
        'lh-12': '12px',
        'lh-16': '16px',
        'lh-22': '22px',
    },
};
exports.default = typography;
